import { Row, Col } from "react-bootstrap"
import Table from '../../../../../../components/Table';

interface ICarbonCountySearchResults {
    webIdLabel: string,
    nameLabel: string,
    addressLabel: string,
    accountIdLabel: string,
    amountDueLabel: string,
    totalAmountDueLabel: string,
    paymentOptionsLabel: string,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    margin: string,
    padding: string,
    headerBackgroundColor : string,
    headerPadding: string,
}

export const WEB_ID_LABEL = 'Web ID';
export const NAME_LABEL = 'Name';
export const ADDRESS_LABEL = 'Address';
export const ACCOUNT_ID_LABEL = 'Account ID';
export const AMOUNT_DUE_LABEL = 'Amount Due';
export const TOTAL_AMOUNT_DUE_LABEL = 'Total Amount Due';
export const PAYMENT_OPTIONS_LABEL = 'Payment Options';
export const OVERLAY_TEXT = 'There are no available online payment options on this account at this time.'; 
export const OVERLAY_BACKGROUND = '#fef1b5'; 
export const OVERLAY_TEXT_COLOR = '#1e1e1e';
export const OVERLAY_ICON_COLOR = 'orange';
export const MARGIN = '0px';
export const PADDING = '0px';
export const HEADER_BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const HEADER_PADDING = '0';

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

const CarbonCountySearchResults = ({ webIdLabel, nameLabel, addressLabel, accountIdLabel, amountDueLabel, totalAmountDueLabel,
    paymentOptionsLabel, overlayText, overlayBackground, overlayTextColor,
    overlayIconColor, margin, padding, headerBackgroundColor ,headerPadding }: ICarbonCountySearchResults) => {

    if (!webIdLabel) { webIdLabel = WEB_ID_LABEL }
    if (!nameLabel) { nameLabel = NAME_LABEL }
    if (!addressLabel) { addressLabel = ADDRESS_LABEL }
    if (!accountIdLabel) { accountIdLabel = ACCOUNT_ID_LABEL }
    if (!amountDueLabel) { amountDueLabel = AMOUNT_DUE_LABEL }
    if (!totalAmountDueLabel) { totalAmountDueLabel = TOTAL_AMOUNT_DUE_LABEL }
    if (!paymentOptionsLabel) { paymentOptionsLabel = PAYMENT_OPTIONS_LABEL }
    if (!overlayText) { overlayText = OVERLAY_TEXT }
    if (!overlayBackground) { overlayBackground = OVERLAY_BACKGROUND }
    if (!overlayTextColor) { overlayTextColor = OVERLAY_TEXT_COLOR }
    if (!overlayIconColor) { overlayIconColor = OVERLAY_ICON_COLOR }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!headerBackgroundColor) { headerBackgroundColor = HEADER_BACKGROUND_COLOR }
    if (!headerPadding) { headerPadding = HEADER_PADDING }
    
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const amountFormatter = (cell: any) => {
        return (<span>{formatter.format(cell)}</span>)
    }

    const initialColumns = [{
        dataField: 'AccountId',
        text: webIdLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'Name1',
        text: nameLabel,
        editable: false,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'Address1',
        text: addressLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        sort: true,
    }, {
        dataField: 'AccountIdDesc1',
        text: accountIdLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        sort: true,
    }, {
        dataField: 'Amt2',
        text: amountDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        formatter: amountFormatter,
        editable: false,
    }, {
        dataField: 'Amt1',
        text: totalAmountDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        formatter: amountFormatter,
        sort: true,
    }, {
        dataField: 'id',
        text: paymentOptionsLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }];

   
    const renderTable = () => {
            return (
                <Table
                    keyField="msbId"
                    data={[]}
                    columns={initialColumns}
                />);
    };

    return (

        <div style={{ margin: margin, padding: padding }}>
            <Row>
                <Col>
                    {renderTable()}
                </Col>
            </Row>
        </div>

    )
}

export default CarbonCountySearchResults;